import { BaseIcon, type BaseIconProps } from '@fountain/ripple/icon';
import React, { forwardRef } from 'react';

// Source: Material-UI RadioButtonUnchecked.
export const RadioUncheckedIcon = forwardRef<SVGSVGElement, BaseIconProps>(
  function RadioUncheckedIcon(props, ref) {
    return (
      <BaseIcon
        ref={ref}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke="none"
        {...props}
      >
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" />
      </BaseIcon>
    );
  },
);
